module.exports = __webpack_public_path__ + "src/app/crm/audiences/assets/welcome.png?20c24d5205ced598871be7611a39eeec";